import PreevaluacionContent from "./Preevaluacion/PreevaluacionContent";

import React from "react";
import { useJumboApp } from "@jumbo/hooks";
import { LAYOUT_NAMES } from "../../../layouts/layouts";

const Preevaluacion = () => {
  const { setActiveLayout } = useJumboApp();

  React.useEffect(() => {
    setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);
  return (
    <div>
      <h2>Solicitud de Crédito Directo</h2>
      <PreevaluacionContent />
    </div>
  );
};

export default Preevaluacion;
